import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import { EventCardWidget } from "./EventCard.jsx";

export function EventListWidget({ configuration }) {
  const [events, setEvents] = useState(configuration.events || []);

  let title = configuration.translations.activeEvents;
  let introText = configuration.translations.introText;

  let out;
  if (events.length > 0) {
    out = (
      <div id="EventListWidget"> 
          <h3 className="section__title--float h4">
            {title}
          </h3>
          <p className="section__description--float">{introText}</p>

          <Slider {...configuration.settings} infinite={events.length > configuration.settings.slidesToShow}>
            {events.map(event =>
              <EventCardWidget
                key={event.slug}
                event={event}
                configuration={configuration}
              />
            )}
          </Slider>
      </div>
    );
  } else {
    out = (
      <div id="EventListWidget">
        <h3 className="section__title--float h4">{title}</h3>
        <div className="min-height-13em">
          <p className="section__description--float my-5">{configuration.translations.emptyMessages}</p>
        </div>
      </div>
    );
  }

  return out;
}
